/**
 * Capacitor: o mesmo codigo roda como app nativo. Todos os plugins sao
 * carregados dinamicamente e degradam para no-op no navegador (PWA), para o
 * bundle web nao depender do runtime nativo.
 */
import { Capacitor } from "@capacitor/core";

export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

export function nativePlatform(): "ios" | "android" | "web" {
  return Capacitor.getPlatform() as "ios" | "android" | "web";
}

/** Deep links + botao fisico de voltar do Android (RF-UX-005). */
export async function setupAppPlugin(onBack: () => void, onDeepLink?: (url: string) => void): Promise<void> {
  if (!isNative()) return;
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("backButton", () => onBack());
    if (onDeepLink) {
      App.addListener("appUrlOpen", (event) => onDeepLink(event.url));
    }
  } catch {
    /* plugin ausente */
  }
}

export async function setupStatusBar(): Promise<void> {
  if (!isNative()) return;
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark });
    if (nativePlatform() === "android") {
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
  } catch {
    /* noop */
  }
}

export async function setupKeyboard(): Promise<void> {
  if (!isNative()) return;
  try {
    const { Keyboard, KeyboardResize } = await import("@capacitor/keyboard");
    await Keyboard.setResizeMode({ mode: KeyboardResize.Native });
  } catch {
    /* noop */
  }
}

/** Push nativo com pre-prompt proprio antes do prompt do SO (RF-UX-044/048). */
export async function registerNativePush(): Promise<{
  granted: boolean;
  provider: "fcm" | "apns" | null;
  token: string | null;
}> {
  if (!isNative()) return { granted: false, provider: null, token: null };
  try {
    const { PushNotifications } = await import("@capacitor/push-notifications");
    const permission = await PushNotifications.requestPermissions();
    if (permission.receive !== "granted") return { granted: false, provider: null, token: null };
    await PushNotifications.register();
    const provider = nativePlatform() === "ios" ? "apns" : "fcm";
    return { granted: true, provider, token: null };
  } catch {
    return { granted: false, provider: null, token: null };
  }
}

/** Token de instalacao estavel por dispositivo (RF-TEN-003). */
export function installationId(): string {
  const key = "zapir.installationId";
  let id = localStorage.getItem(key);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(key, id);
  }
  return id;
}
